<!--
  充值优惠
  lovi 2020-1-10
-->
<template>
  <div>
    <van-popup v-model="popupFlag" get-container="body" position="bottom">
      <div class="title">
        {{ $t("common.discountDesc") }}
        <span class="text-orange" @click="popupFlag = false">
          {{ $t("common.confirm") }}
        </span>
      </div>
      <ul class="discounts-list">
        <li v-for="(item, index) in list" :key="index">
          <h3 class="text-orange">
            [{{ index + 1 }}] {{ item.discount_name }}
          </h3>
          <p>{{ item.discount_type }}</p>
          <p>{{ item.discount_remark }}</p>
        </li>
      </ul>
    </van-popup>
  </div>
</template>

<script>
export default {
  props: {
    discountFlag: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  components: {},
  data() {
    return {
      popupFlag: false
    };
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {},
  watch: {
    discountFlag(bol) {
      this.popupFlag = bol;
    },
    popupFlag(bol) {
      this.$emit("update:discountFlag", bol);
    }
  }
};
</script>

<style lang="less" scoped>
.title {
  position: relative;
  text-align: center;
  height: 40px;
  line-height: 39px;
  font-size: 16px;
  border-bottom: 1.1px solid #eee;
  span {
    position: absolute;
    top: 10px;
    right: 15px;
    font-size: 14px;
    line-height: 20px;
  }
}
.discounts-list {
  height: 260px;
  overflow-y: auto;
  padding: 15px;
  line-height: 1.4;
  li {
    margin-top: 12px;
    &:nth-of-type(1) {
      margin-top: 0;
    }
    h3 {
      font-size: 16px;
      font-weight: 500;
    }
    p {
      margin-top: 4px;
    }
  }
}
</style>
